<template>
  <div class="width100">
    <section class="video-background">
      <div class="bg-black"></div>

      <div id="video-poster" class="video-poster">
        <video :src="require('@/assets/mina_video2.mp4')" poster="../../assets/video-cobre.jpeg" autoplay muted loop
          playsinline></video>
      </div>
    </section>

    <div class="secondary-content">
      <section class="about-info-title">
        <div>
          <div class="text-center">
            <p class="large-text">
              <span v-html="filterData('COBRE_HOME_01_' + language)"></span>
            </p>
            <a href="https://cobre.cobredelmayo.com/home" target="_blank" class="btn primary-btn">Frontera</a>
          </div>
        </div>
      </section>

      <section class="bg-iframe">
        <div class="about-info text-center">
          <section class="">
            <iframe class="video-frame"
              src="https://www.youtube.com/embed/Eso5ZZPPATw" title="YouTube video player" frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen="">
            </iframe>
          </section>
        </div>
      </section>

      <section class="gallery-section">
        <div class="about-info text-center">
          <div class="width100">
            <div class="custom-gallery-grid">
              <!-- Imagen 1 -->
              <div class="image image-1" @click="openImageModal('COBRE_HOME_1')">
                <img 
                  :src="getImageUrl('COBRE_HOME_1', `${BASEURL}/misc/img/site/gallery/img-gallery-01.jpg`)" 
                  @error="(e) => e.target.src = `${BASEURL}/misc/img/site/gallery/img-gallery-01.jpg`"
                  alt="Image 1"
                  loading="lazy"
                />
              </div>
              <!-- Imagen 2 -->
              <div class="image image-2" @click="openImageModal('COBRE_HOME_2')">
                <img 
                  :src="getImageUrl('COBRE_HOME_2', `${BASEURL}/misc/img/site/gallery/img-gallery-02.jpg`)" 
                  @error="(e) => e.target.src = `${BASEURL}/misc/img/site/gallery/img-gallery-02.jpg`"
                  alt="Image 2"
                  loading="lazy"
                />
              </div>
              <!-- Imagen 3 -->
              <div class="image image-3" @click="openImageModal('COBRE_HOME_3')">
                <img 
                  :src="getImageUrl('COBRE_HOME_3', `${BASEURL}/misc/img/site/gallery/img-gallery-03.jpg`)" 
                  @error="(e) => e.target.src = `${BASEURL}/misc/img/site/gallery/img-gallery-03.jpg`"
                  alt="Image 3"
                  loading="lazy"
                />
              </div>
              <!-- Imagen 4 -->
              <div class="image image-4" @click="openImageModal('COBRE_HOME_4')">
                <img 
                  :src="getImageUrl('COBRE_HOME_4', `${BASEURL}/misc/img/site/gallery/img-gallery-04.jpg`)" 
                  @error="(e) => e.target.src = `${BASEURL}/misc/img/site/gallery/img-gallery-04.jpg`"
                  alt="Image 4"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- Modal Mejorado -->
      <div v-if="modalVisible" class="modal" @click="closeModal" @keydown.esc="closeModal" tabindex="0">
        <div class="modal-content" @click.stop>
          <button class="modal-close" @click="closeModal">✕</button>
          <img :src="selectedImage" alt="Imagen grande" />

          <!-- Botones navegación -->
          <button class="nav-button prev" @click="prevImage">←</button>
          <button class="nav-button next" @click="nextImage">→</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, computed } from "vue";
import { BASEURL } from "@/kernel/utils";
import { getImageBySection, getSectionByPageandlanguage } from "@/public/services/sections-service";

export default {
  setup() {
    const selectedImage = ref(null);
    const modalVisible = ref(false);
    const currentIndex = ref(0);
   const language = 'EN';
    const dataHome = ref([
      {
        section_id: "COBRE_HOME_01_EN",
        description: "For more information, visit our parent company’s website,<br /> Frontera Copper Corporation",
      },
      {
        section_id: "COBRE_HOME_01_ES",
        description: "For more information, visit our parent company’s website,<br /> Frontera Copper Corporation",
      },
    ]);

    const fetchData = async () => {
      try {
        const dataForm = {
          page: "HOME-COBRE",
          language: language,
        };
        const response = await getSectionByPageandlanguage(dataForm);
        if (response.status === 200) {
          if (parseInt(response.data.length) !== 0) {
            dataHome.value = response.data;
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const filterData = (found_id) => {
      const filteredData = dataHome.value.filter(
        (item) => item.section_id === found_id
      );
      return filteredData.length > 0 ? filteredData[0].description : null;
    };

    const imagesAbout = ref([]);

    const searchImage = (imageId, defaultImage) => {
      const foundImage = imagesAbout.value.find(image => image.image_id === imageId);
      return foundImage ? BASEURL + foundImage.image_path : defaultImage;
    };


    const getImages = async () => {
      try {
        const dataForm = {
          page: "HOME-COBRE",
        };
        const result = await getImageBySection(dataForm);
        if (result.status === 200) {
          if (result.data.content !== null) {
            imagesAbout.value = result.data.content;
          }
        }
      } catch (error) {
        console.log("Error fetching images:", error);
      }
    };

    onMounted(() => {
      fetchData();
      getImages();
    });

    const getImageUrl = (imageId, defaultImage) => {
      const foundImage = imagesAbout.value.find(
        (image) => image.image_id === imageId
      );
      return foundImage ? BASEURL + foundImage.image_path : defaultImage;
    };

    const images = computed(() => [
      searchImage('COBRE_HOME_1', `${BASEURL}/misc/img/site/gallery/img-gallery-01.jpg`),
      searchImage('COBRE_HOME_2', `${BASEURL}/misc/img/site/gallery/img-gallery-02.jpg`),
      searchImage('COBRE_HOME_3', `${BASEURL}/misc/img/site/gallery/img-gallery-03.jpg`),
      searchImage('COBRE_HOME_4', `${BASEURL}/misc/img/site/gallery/img-gallery-04.jpg`),
    ]);

    const openImageModal = (imageId) => {
      const imageUrl = getImageUrl(
        imageId, 
        `${BASEURL}/misc/img/site/gallery/img-gallery-0${imageId.slice(-1)}.jpg`
      );
      selectedImage.value = imageUrl;
      // Find the index in the images array that matches this image
      currentIndex.value = images.value.findIndex(img => img.includes(`img-gallery-0${imageId.slice(-1)}.jpg`));
      modalVisible.value = true;

      // Activar eventos del teclado (como ESC)
      setTimeout(() => {
        document.querySelector(".modal")?.focus();
      }, 50);
    };

    const openModal = (src) => {
      currentIndex.value = images.value.indexOf(src);
      selectedImage.value = src;
      modalVisible.value = true;

      // Para activar eventos del teclado (como ESC)
      setTimeout(() => {
        document.querySelector(".modal")?.focus();
      }, 50);
    };

    const closeModal = () => {
      modalVisible.value = false;
    };

    const nextImage = () => {
      currentIndex.value = (currentIndex.value + 1) % images.value.length;
      selectedImage.value = images.value[currentIndex.value];
    };

    const prevImage = () => {
      currentIndex.value =
        (currentIndex.value - 1 + images.value.length) % images.value.length;
      selectedImage.value = images.value[currentIndex.value];
    };


    return {
      BASEURL,
      selectedImage,
      modalVisible,
      openModal,
      closeModal,
      nextImage,
      prevImage,
      openImageModal,
      getImageUrl,
      imagesAbout,
      language,
      filterData,
      searchImage,
    };
  },
  name: "HomePage",
};
</script>

<style scoped>
.bg-black {
    position: relative;
    width: 100%;
    height: 140px;
    background-color: #000;
    z-index: -1 !important;
}

.video-background {
    position: relative;
    height: 80vh;
    min-width: 50vw;
    overflow: hidden;
    background-color: #d32a28;
    z-index: -1 !important;
}

.vimeo-wrapper {
    position: relative;
    z-index: 6;
    margin-top: -120px;
    height: 80vh;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
}

.video-poster {
    position: absolute;
    margin-top: -120px;
    width: 98%;
    height: 80vh;
    z-index: 5;
    left: 1%;
    transition: opacity 0.5s erase;
}

.video-poster.hidden {
    opacity: 0;
    pointer-events: none;
}

.video-poster video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    object-position: center;
}

.video-background iframe {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    transform: translate(-50%, -50%);
}

.secondary-content {
    background-color: #e4e5e5;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.bg-iframe {
    width: 100%;
    background-color: black;
    padding-top: 1.7rem;
    padding-bottom: 1.7rem;
}

.video-frame {
    width: 100%;
    height: 515px;
}

@media screen and (max-width: 768px) {
    .bg-iframe {
        padding: 0;
    }

    .embed-responsive-item {
        width: 100%;
        height: 100%;
    }

    .video-frame {
        width: 100%;
        height: 100%;
    }
}


.light-section,
.iframe-section,
.gallery-wrapper {
  background-color: #e4e5e5;
  padding: 24px;
}

.gallery-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f05a29;
}

.gallery-section {
  width: 100%;
  background-image: url("../../assets/bg-svg.svg");
  background-position: center;
  background-repeat: no-repeat;
  background-color: #f05a29;
  padding-top: 1.7rem !important;
  padding-bottom: 1.7rem !important;
}

.text-center {
  text-align: center;
}

.large-text {
  font-size: 1.5rem;
  margin-bottom: 16px;
}

.btn {
  display: inline-block;
  padding: 10px 20px;
  border-radius: 5px;
  text-decoration: none;
  color: #fff;
  background-color: #df510f;
  transition: background-color 0.3s;
}

.primary-btn:hover {
  background-color: #893e01;
}

.responsive-embed {
  position: relative;
  width: 100%;
  padding-top: 56.25%;
}

.responsive-embed iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.custom-gallery-grid {
  display: grid;
  grid-template-areas:
    "img1 img2 img3"
    "img4 img4 img4";
  grid-template-columns: repeat(3, 348px); /* ancho fijo */
  gap: 48px;
  justify-content: center;
  align-items: start;
  max-width: calc((348px * 3) + (48px * 2)); /* ancho total más gaps */
}

/* Imágenes cuadradas (1, 2 y 3) */
.image {
  width: 348px;
  height: 348px;
  overflow: hidden;
  border-radius: 4px;
}

.image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  border-radius: 4px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.image img:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
}

/* Imagen 4: tamaño original */
.image-4 {
  grid-area: img4;
  grid-column: span 3;
  width: 100%;
  height: 300px;
  overflow: hidden;
  border-radius: 4px;
}

.image-4 img {
  width: 100%;
  height: 100%;
  object-fit: cover; /* o 'contain' si prefieres */
  border-radius: 4px;
}


/* Responsive */
@media (max-width: 768px) {
  .gallery-section {
    padding-top: 0.6rem !important;
    padding-bottom: 0.6rem !important;
  }
 .custom-gallery-grid {
  display: grid;
  grid-template-areas:
    "img1 img2 img3"
    "img4 img4 img4";
  grid-template-columns: repeat(3, 116px); /* ancho fijo */
  gap: 16px;
  max-width: calc((116px * 3) + (16px * 2)); /* ancho total más gaps */
}

/* Imágenes cuadradas (1, 2 y 3) */
.image {
  width: 116px;
  height: 116px;

}
.image-4 img {
  width: 100%;
  height: 100%;
  object-fit: cover; /* o 'contain' si prefieres */
  border-radius: 4px;
}

.image-4 {
  grid-area: img4;
  grid-column: span 3;
  width: 100%;
  height: 100px;
  overflow: hidden;
  border-radius: 4px;
}
}

/* Estilos para el Modal */
.modal {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.85);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  outline: none;
}

.modal-content {
  position: relative;
  max-width: 90%;
  max-height: 90%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 0 20px rgba(255, 255, 255, 0.15);
}

.modal-close {
  position: absolute;
  top: -12px;
  right: -12px;
  background: #fff;
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.nav-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.85);
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
  user-select: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.nav-button.prev {
  left: -50px;
}

.nav-button.next {
  right: -50px;
}

@media (max-width: 768px) {
  .nav-button.prev {
    left: 10px;
  }

  .nav-button.next {
    right: 10px;
  }
}
</style>
